import { createContext, useContext, type ReactNode } from 'react';

/** Built-in texts and locale of the components (labels, placeholders). Spanish by default. */
export interface UiLabels {
  close: string;
  loading: string;
  online: string;
  offline: string;
  choose: string;
  /** Date picker. */
  today: string;
  clear: string;
  previousMonth: string;
  nextMonth: string;
  noDate: string;
  /** BCP 47 locale for month/day names and times (e.g. 'es-ES', 'en-GB'). */
  locale: string;
}

export const defaultUiLabels: UiLabels = {
  close: 'Cerrar',
  loading: 'Cargando',
  online: 'En línea',
  offline: 'Desconectado',
  choose: 'Elige…',
  today: 'Hoy',
  clear: 'Quitar',
  previousMonth: 'Mes anterior',
  nextMonth: 'Mes siguiente',
  noDate: 'Sin fecha',
  locale: 'es-ES',
};

const UiLabelsContext = createContext<UiLabels>(defaultUiLabels);

/** Lets the app translate the components' built-in texts without the package knowing about i18n. */
export function UiLabelsProvider({
  labels,
  children,
}: {
  labels: Partial<UiLabels>;
  children: ReactNode;
}) {
  return (
    <UiLabelsContext.Provider value={{ ...defaultUiLabels, ...labels }}>
      {children}
    </UiLabelsContext.Provider>
  );
}

export const useUiLabels = (): UiLabels => useContext(UiLabelsContext);
